import { withRouter } from 'react-router';
import { NotFoundPageComponent } from './not-found-page';
export const NotFoundPage = withRouter(NotFoundPageComponent);